import { Box, alpha, useTheme } from '@mui/material';

const AmbientBackground = () => {
	const theme = useTheme();
	const isDark = theme.palette.mode === 'dark';

	return (
		<Box
			aria-hidden
			sx={{
				position: 'fixed',
				inset: 0,
				zIndex: 0,
				overflow: 'hidden',
				pointerEvents: 'none',
				bgcolor: 'background.default',
			}}
		>
			<Box
				sx={{
					position: 'absolute',
					width: '70vmax',
					height: '70vmax',
					top: '-20%',
					right: '-15%',
					borderRadius: '50%',
					background: isDark
						? `radial-gradient(circle, ${alpha('#5A8AAD', 0.16)} 0%, transparent 70%)`
						: `radial-gradient(circle, ${alpha('#7BA3C4', 0.2)} 0%, transparent 70%)`,
					animation: 'ambientDrift1 22s ease-in-out infinite',
					'@keyframes ambientDrift1': {
						'0%, 100%': { transform: 'translate(0, 0) scale(1)' },
						'33%': { transform: 'translate(-5%, 8%) scale(1.05)' },
						'66%': { transform: 'translate(3%, -4%) scale(0.95)' },
					},
				}}
			/>
			<Box
				sx={{
					position: 'absolute',
					width: '55vmax',
					height: '55vmax',
					bottom: '-15%',
					left: '-10%',
					borderRadius: '50%',
					background: isDark
						? `radial-gradient(circle, ${alpha('#6B8FA8', 0.12)} 0%, transparent 70%)`
						: `radial-gradient(circle, ${alpha('#9BB5C9', 0.16)} 0%, transparent 70%)`,
					animation: 'ambientDrift2 28s ease-in-out infinite',
					'@keyframes ambientDrift2': {
						'0%, 100%': { transform: 'translate(0, 0) scale(1)' },
						'50%': { transform: 'translate(8%, -6%) scale(1.08)' },
					},
				}}
			/>
			<Box
				sx={{
					position: 'absolute',
					width: '40vmax',
					height: '40vmax',
					top: '40%',
					left: '30%',
					borderRadius: '50%',
					background: isDark
						? `radial-gradient(circle, ${alpha('#5BA8B5', 0.08)} 0%, transparent 70%)`
						: `radial-gradient(circle, ${alpha('#7BB8C4', 0.1)} 0%, transparent 70%)`,
					animation: 'ambientDrift3 18s ease-in-out infinite',
					'@keyframes ambientDrift3': {
						'0%, 100%': { transform: 'translate(0, 0)' },
						'25%': { transform: 'translate(-6%, 4%)' },
						'75%': { transform: 'translate(4%, -5%)' },
					},
				}}
			/>
			<Box
				sx={{
					position: 'absolute',
					inset: 0,
					opacity: isDark ? 0.03 : 0.025,
					backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
				}}
			/>
		</Box>
	);
};

export default AmbientBackground;
